module.exports = __webpack_public_path__ + "static/media/Fairytale-100.03656d91.webp";